module.exports = __webpack_public_path__ + "static/img/title_1_blue@2x.b5d26136.png";